module.exports = __webpack_public_path__ + "static/media/logo-azapfy-web.e9d22001.png";